import React from 'react'
import {
  Box,
  List,
  ListSubheader as MuiListSubheader,
  Typography
} from '@material-ui/core'
import { useAppContext } from '../../app/hooks'
import { PanelListItem } from '../../../../shared/components/Panels/PanelList'
import SedaMetricSlider from './SedaMetricSlider'
import SedaFilterLocation from './SedaFilterLocation'
import { formatInteger } from '../../../../shared/utils'
import SedaAreaClassification from './SedaAreaClassification'
import SedaSchoolType from './SedaSchoolType'
import SedaAgeGroup from './SedaAgeGroup'
import { getLang, getPrefixLang } from '../../app/selectors/lang'
import SedaMetricMenu from './SedaMetricFilterMenu'
import { Add } from '@material-ui/icons'
import SedaFilterSize from './SedaFilterSize'
import { useFilterStore } from '../../../filters'
import { withStyles } from '@material-ui/styles'

const ListSubheader = withStyles(theme => ({
  root: {
    marginBottom: theme.spacing(-1)
  }
}))(MuiListSubheader)

/**
 * Contains all controls for modifying filters
 */
const SedaFiltersForm = props => {
  const {
    filterResults,
    totalResults,
    region,
    metric: activeMetric
  } = useAppContext()

  const removeFilter = useFilterStore(
    state => state.removeFilter
  )

  // TODO: only show metric sliders that are added
  // const [filterMetrics, setFilterMetrics] = useState([])

  const isFiltered = filterResults !== totalResults

  const metrics = [
    'avg',
    'grd',
    'coh',
    region === 'schools' ? 'frl' : 'ses'
  ]

  const [filterMetrics, setFilterMetrics] = React.useState([])
  const menuMetrics = metrics.filter(
    m => filterMetrics.indexOf(m) === -1
  )

  const handleAddMetric = metric => {
    setFilterMetrics(filterMetrics.concat(metric))
  }

  const handleRemoveMetric = metric => {
    setFilterMetrics(filterMetrics.filter(m => m !== metric))
    removeFilter(['range', metric], true)
  }

  return (
    <List {...props}>
      <PanelListItem>
        {isFiltered ? (
          <Typography variant="body1">
            Showing {formatInteger(filterResults)} of{' '}
            {formatInteger(totalResults)} {region}
          </Typography>
        ) : (
          <Typography variant="body1">
            Showing all {formatInteger(totalResults)} {region}
          </Typography>
        )}
      </PanelListItem>
      {region !== 'states' && (
        <ListSubheader disableSticky>
          <div>
            Filter By Location
          </div>
        </ListSubheader>
      )}
      {region !== 'states' && <SedaFilterLocation />}
      <ListSubheader disableSticky>
        <div>
          Filter By Classification
        </div>
      </ListSubheader>
      <PanelListItem
        title={getPrefixLang('size', 'FILTER_LABEL')}
        desc={getPrefixLang('size_desc', 'FILTER_LABEL')}>
        <SedaFilterSize region={region} />
      </PanelListItem>
      <PanelListItem title={getLang('FLAG_LABEL_AREA')}>
        <SedaAreaClassification region={region} />
      </PanelListItem>
      <PanelListItem title={getLang('FLAG_LABEL_SCHOOL')}>
        <SedaSchoolType region={region} />
      </PanelListItem>
      <PanelListItem title={getLang('FLAG_LABEL_AGE')}>
        <SedaAgeGroup region={region} />
      </PanelListItem>
      <ListSubheader disableSticky>
        <div>
          Filter By Metric
        </div>
      </ListSubheader>
      <PanelListItem>
        {filterMetrics.length === 0 && (
          <Box clone pt={0} pb={1} color="text.secondary">
            <Typography variant="body1">
              No metrics currently selected
            </Typography>
          </Box>
        )}
        {filterMetrics.map(metric => (
          <SedaMetricSlider
            key={metric}
            metricId={metric}
            isActive={metric === activeMetric}
            onDismiss={handleRemoveMetric}
          />
        ))}
        <SedaMetricMenu
          metrics={menuMetrics}
          onSelect={handleAddMetric}
          empty={menuMetrics.length === 0 ? true : false}>
          <Add
            style={{
              fontSize: 16,
              marginRight: 8,
              marginTop: -2
            }}
          />{' '}
          Add a metric filter
        </SedaMetricMenu>
      </PanelListItem>
    </List>
  )
}

export default SedaFiltersForm
